import { useEffect, useRef, useState } from "react";
import {
  ExcelBtn,
  formBtn1,
  formBtn2,
  inputClass,
  pageClass,
  pageHeader,
  pdfBtn,
} from "../Utils/CustomClasses";
import Table from "../Table/Table";
import DeleteLeadModal from "../Modals/DeleteLeadModal";
import Select from "react-select";
import {
  AssignLeadsAPI,
  AssignUserAPI,
  GetAllCompanyAPI,
  GetAllLeadsAPI,
} from "../../API/Api";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../Redux/Slice/LoginSlice";
import { Controller, useForm } from "react-hook-form";
import { Checkbox } from "antd";
import { toast } from "react-toastify";
import { customStyles, downloadCSV, downloadTablePDF, truncateText } from "../Utils/CommonFuntion";
import AddLeadd from "../Modals/AddLeadd";
import usePaginatedData from "../Utils/UsePagination";
import { useLocation, useNavigate } from "react-router-dom";
import { useThemeColor } from "../Sidebar/SideBarApi";
import Error from "../Error/Error";
import AddLead2 from "../Modals/AddLead2";
import moment from "moment";
import { DatePicker, Space } from "antd";
import ModifyCallTimeModal from "../Modals/ModifyCallTimeModal";
import DeleteMultipleLeads from "../Modals/DeleteMultipleLeads";
import { IconEye, IconPhone } from "@tabler/icons-react";
import { LeadStatusStyles } from "../Utils/StaticData";

export default function Lead1() {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
    watch,
    setValue
  } = useForm();
  const {
    register: registerForm1,
    handleSubmit: handleSubmitForm1,
    reset: resetForm1,
    watch: watchForm1,
    control: controlForm1,
    formState: { errors: errorsForm1, isValid: isValidForm1 },
  } = useForm();
  const location = useLocation();
  const userDetails = useSelector((state) => state?.login?.userDetails);
  const companyDetails = useSelector((state) => state?.login?.userDetails?.company);
  const leadStatusOptions = companyDetails?.allowedLeadStatus || [];
  const [selectedRows, setSelectedRows] = useState([]);
  const [RowCheck, setRowCheck] = useState(false);
  const [AssignUsers, setAssignUsers] = useState([]);
  const [RowId, setRowId] = useState([]);
  const [Company, setCompany] = useState([]);
  const [isApplyDisabled, setIsApplyDisabled] = useState(true);
  const filterTimeout = useRef();
  const isFirstRender = useRef(true);
  const navigate = useNavigate();
  const themeColor = useThemeColor();
  const dispatch = useDispatch();
  const { RangePicker } = DatePicker;
  const searchValue = watchForm1("search");
  const leadStatusValue = watchForm1("leadStatus");
  const phoneNumber = watchForm1("phoneNumber");
  const rangeDate = watchForm1("rangeDate");
  const UserDetails = useSelector((state) => state?.login?.userDetails);

  useEffect(() => {
    setIsApplyDisabled(!(searchValue || leadStatusValue || phoneNumber || rangeDate));
  }, [searchValue, leadStatusValue, phoneNumber, rangeDate]);

  const initialFilterState = {
    p: 1,
    id: userDetails?._id || "",
    leadStatus: "",
    search: "",
    role: userDetails?.role?.roleName || "",
    companyId:
      userDetails?.role?.roleName == "SuperAdmin"
        ? ""
        : userDetails?.company?._id,
  };

  const [filterObject, setFilterObject] = useState({
    ...initialFilterState,
    p: location.state?.restorePage || 1,
  });

  const {
    filterData: LeadsData,
    pageNo,
    pageChangeHandler,
    recordChangeHandler,
    fetchData,
    nextIsValid,
    prevIsValid,
    records,
    loader,
  } = usePaginatedData(1, location.state?.restoreRecords || 50, GetAllLeadsAPI, filterObject);

  const assignToOptions =
    AssignUsers != undefined
      ? AssignUsers.map((user) => ({
        value: user?._id,
        label: `${user?.first_name} ${user?.last_name}`,
      }))
      : [{ value: "", label: "No data found" }];

  // Function to select/deselect a single row
  const handleRowSelect = (rowId, checked) => {
    setSelectedRows((prevSelected) => {
      let updatedSelection;
      if (checked) {
        updatedSelection = [...prevSelected, rowId]; // Select the row
      } else {
        updatedSelection = prevSelected.filter((id) => id !== rowId); // Deselect the row
      }

      // Set RowCheck to true only if there are still selected rows
      setRowCheck(updatedSelection.length > 0);
      setRowId(updatedSelection);
      return updatedSelection;
    });
  };

  // "Select All" functionality
  const handleSelectAll = (checked) => {
    if (checked) {
      const allRowIds = LeadsData?.map((row) => row?._id);
      setSelectedRows(allRowIds);
      setRowId(allRowIds)
      setRowCheck(true);
    } else {
      setSelectedRows([]);
      setRowCheck(false);
    }
  };

  const tableColumns = [
    {
      field: "select",
      header: LeadsData?.length > 0 && (
        <Checkbox
          checked={
            selectedRows?.length === LeadsData?.length && LeadsData?.length > 0
          }
          indeterminate={false} // Show indeterminate state
          onChange={(e) => handleSelectAll(e.target.checked)}
        />
      ),
      style: true,
      className: "col-select",
      body: (row) => (
        <Controller
          name={`selected_${row.id}`}
          control={control}
          render={() => (
            <Checkbox
              checked={selectedRows.includes(row._id)}
              onChange={(e) => handleRowSelect(row._id, e.target.checked)}
            />
          )}
        />
      ),
    },
    {
      field: "sr_no",
      header: "Sr No",
      style: true,
      body: (row, meta) => {
        return <h6>{(pageNo - 1) * Number(records) + meta.rowIndex + 1}</h6>;
      },
    },
    {
      field: "createdAt",
      header: "Created At",
      style: true,
      body: (row) => (
        <h6>{row?.createdAt ?  moment(row.createdAt).format("DD-MM-YYYY") : "-----"}</h6>
      ),
    },
    {
      field: "location",
      header: "Location",
      style: true,
      className: "col-location",
      body: (row) => {
        const fullText = `${row?.city || ""}${row?.city && row?.state ? ", " : ""}${row?.state || ""}`;
        return (
          <>
            <h6 title={fullText}>
              {truncateText(fullText)}
            </h6>
            <h6>{row?.pincode || "----"}</h6>
          </>
        );
      },
    },
    {
      field: "fullName",
      header: "Full Name",
      style: true,
      className: "col-name",
      body: (row) => {
        const fullName = `${row?.firstName || ""} ${row?.lastName || ""}`.trim();
        return (
          <h6 title={fullName || "-----"}>
            {truncateText(fullName, 30)}
          </h6>
        );
      },
    },
    {
      field: "email",
      header: "Email",
      style: true,
      body: (row) => (
        <h6 title={row?.email || "-----"}>
          {truncateText(row?.email || "", 30)}
        </h6>
      ),
    },
    {
      field: "phoneNumber",
      header: "Phone Details",
      style: true,
      className: "col-phone",
      body: (row) => {
        return (
          <>
            <h6>{row?.phoneNumber || "----"}</h6>
          </>
        );
      },
    },
    {
      field: "alternateNumber",
      header: "Alternate Number",
      style: true,
      body: (row) => <h6>{row?.alternateNumber || "------"}</h6>,
    },
    {
      field: "leadSource",
      header: "Lead Source",
      style: true,
      body: (row) => <h6>{row?.leadSource || "-----"}</h6>,
    },
    {
      field: "product",
      header: "Product",
      style: true,
      body: (row) => <h6>{row?.product || "-----"}</h6>,
    },
    userDetails?.role?.roleName === "SuperAdmin" && {
      field: "company",
      header: "Company",
      style: true,
      body: (row) => <h6>{row?.company?.companyName || "-----"}</h6>,
    },
    {
      field: "assigned_to",
      header: "Assigned To",
      style: true,
      body: (row) => (
        <h6>
          {row?.assigned_to?.first_name && row?.assigned_to?.last_name
            ? `${row.assigned_to.first_name} ${row.assigned_to.last_name}`
            : "----"}
        </h6>
      ),
    },
    {
      field: "followUpDetails",
      header: "FDetails",
      style: true,
      body: (row) => {
        const followDate = row?.followDate;
        const followTime = row?.followTime;
        const followDateDetails = (followDate) ? moment(row?.followDate).format("DD-MM-YYYY") : "-----";
        const followTimeDetails = (followTime) ? `${followTime}` : "-----";
        return(
          <>
            <h6>{followDateDetails}</h6>
            <h6>{followTimeDetails}</h6>
          </>
        );
},
    },
    {
      field: "leadStatus",
      header: "Lead Status",
      style: true,
      className: "col-status",
      body: (row) => <LeadStatusStyles leadStatus={row?.leadStatus} />,
    },
    {
      field: "remark",
      header: "Remark",
      style: true,
      className: "col-status",
      body: (row) => <h6 className='break-words whitespace-pre-line min-w-[20rem]'>{row?.remark || "-----"}</h6>,
    },
    {
      field: "lastCallDateTime",
      header: "Last call Date / Time",
      style: true,
      body: (row) => (
        <h6>
          {row?.lastCallDateTime
            ? moment(row?.lastCallDateTime).format("DD-MM-YYYY hh:mm:ss A")
            : "---"}
        </h6>
      ),
    },
    {
      field: "actions",
      header: "Actions",
      style: true,
      className: "col-actions",
      body: (row) => (
        <div className="flex items-center w-full gap-x-2">
          <button
            onClick={(e) => {
              e.preventDefault();
              HandleViewLead(row);
            }}
            className="py-1 rounded-lg flex justify-center"
          >
            <IconEye size={24} className="text-black" color="#000" stroke={1.5} />
          </button>
          <AddLeadd
            edit={true}
            rowdata={row}
            Company={Company}
            iniAssignUsers={AssignUsers}
            filterRecords={() => filterRecords(true)}
          />
          {row?.assigned_to?.first_name && row?.assigned_to?.last_name ? (
            // <CallTimeModal rowdata={row} filterRecords={() => filterRecords(true)} filterSubmit={filterSubmit} />
            <button
              onClick={(e) => {
                e.preventDefault();
                dispatch(
                  openModal({
                    isOpenModal: true,
                    modalData: { rowdata: row },
                  }),
                );
              }}
            >
              <IconPhone size={23} className="text-black" color="#000" stroke={1.5} />
            </button>
          ) : null}
          {(userDetails?.role?.roleName == "SuperAdmin" ||
            userDetails?.role?.roleName == "Admin") && (
              <DeleteLeadModal
                row={row}
                filterRecords={() => filterRecords(true)}
              />
            )}
        </div>
      ),
    },
  ].filter(Boolean);

  const allowedFields = companyDetails?.allowedLeadTableFields || [];

  let filteredColumns = tableColumns;

  if (allowedFields.length > 0) {
    filteredColumns = tableColumns.filter((col) => {
      return (
        col.field === "select" ||
        col.field === "sr_no" ||
        col.field === "createdAt" ||
        col.field === "actions" ||
        allowedFields.includes(col.field)
      );
    });
  }

  const HandleViewLead = (row) => {
    navigate("/teamleads-detail", { state: { leadData: row,fromPage: pageNo,from: "Lead1", restoreRecords: records } });
  };

  const handleAssignChange = async (selectedOption) => {
    try {
      let response = await AssignUserAPI({
        id: userDetails?._id,
        role: userDetails?.role?.roleName,
        search: selectedOption,
        company:
          userDetails?.role?.roleName == "Admin"
            ? userDetails?.company?._id
            : "",
      });
      setAssignUsers(response?.data?.filteredData);
    } catch (error) {
      console.error("Error assigning user:", error);
    }
  };

  const handleCompanySelect = async (id) => {
    setValue("assign_user", null);
    setAssignUsers([]);
    try {
      let response = await AssignUserAPI({
        id: userDetails?._id,
        role: userDetails?.role?.roleName,
        company:
          userDetails?.role?.roleName == "SuperAdmin"
            ? id
            : userDetails?.company?._id,
      });
      setAssignUsers(response?.data?.filteredData);
    } catch (err) {
      console.log("Error:", err);
    }
  };

  const filterRecords = (maintainPage = false) => {
    if (filterTimeout.current) {
      clearTimeout(filterTimeout.current);
    }
    filterTimeout.current = setTimeout(async () => {
      const currentPage = maintainPage ? pageNo : 1;
      await fetchData({ ...filterObject, p: currentPage });
      filterTimeout.current = null;
    }, 1500);

    return () => {
      if (filterTimeout.current) {
        clearTimeout(filterTimeout.current);
      }
    };
  };

  const getallCompany = async () => {
    try {
      const parentCompanyId = userDetails?.role?.roleName === "SuperAdmin" ? userDetails?.company?._id : "";
      const res = await GetAllCompanyAPI(parentCompanyId);
      setCompany(res?.data?.filteredData);
    } catch (err) {
      console.log("Error:", err);
    }
  };

  const HandleAssignUsers = async (data) => {
    const payload = {
      leadId: RowId,
      userId: data?.assign_user?.value,
      leadStatus: "Assigned",
      remark: data?.remark,
    };
    try {
      let response = await AssignLeadsAPI(payload);
      if (response?.status == 200) {
        toast.success(response?.data?.message);
        reset({ assign_user: null, companyId: null });
        filterRecords(true);
        setRowCheck(false);
        setSelectedRows([]);
      } else {
        toast.error(response?.response?.data?.error);
        reset({ assign_user: null, companyId: null });
        filterRecords(true);
        setRowCheck(false);
        setSelectedRows([]);
      }
    } catch (err) {
      console.log("Error:", err);
    }
  };

  const submitPdfExcel = (download) => {
    const Header = [
      "firstName",
      "lastName",
      "email",
      "phoneNumber",
      "createdAt",
      "alternateNumber",
      "leadSource",
      "pincode",
      "city",
      "state",
      "product",
      "assigned_to",
      "leadStatus",
      "remark",
      "followDate",
      "followTime",
      "callStart",
    ];
    const formattedLeadsData = LeadsData?.map((lead) => ({
      ...lead,
      assigned_to: `${lead?.assigned_to?.first_name || ""} ${lead?.assigned_to?.last_name || ""
        }`.trim(),
      company: lead?.company?.companyName || "",
    }));
    download === "Csv"
      ? downloadCSV(Header, formattedLeadsData, "Leads")
      : downloadTablePDF(Header, formattedLeadsData, "Leads");
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    filterRecords();
  }, [filterObject]);

  useEffect(() => {
    if (userDetails?.role?.roleName === "SuperAdmin") {
      getallCompany();
    }
    const level = Number(userDetails?.role?.hierarchyLevel);
    if (userDetails?.role?.roleName === "Admin" || level === 2) {
      handleCompanySelect(userDetails?.company?._id);
      getallCompany();
    }
  }, []);

  const filterSubmit = async (data) => {
    let startDateFormatted = "";
    let endDateFormatted = "";
    if (data?.rangeDate != undefined && data?.rangeDate?.length != 0) {
      const startDate = `${data?.rangeDate[0].$D}-${
      data?.rangeDate[0].$M + 1
        }-${data?.rangeDate[0].$y}`;
      const endDate = `${data?.rangeDate[1].$D}-${data?.rangeDate[1].$M + 1}-${
        data?.rangeDate[1].$y
        }`;
      startDateFormatted = moment(startDate, "DD-MM-YYYY").format("YYYY-MM-DD");
      endDateFormatted = moment(endDate, "DD-MM-YYYY").format("YYYY-MM-DD");
    }
    const payload = {
      ...filterObject,
      p: pageNo,
      search: data?.search ? data?.search : "",
      phoneNumber: data?.phoneNumber ? data?.phoneNumber : "",
      leadStatus: data?.leadStatus ? data?.leadStatus : "",
      startDate: startDateFormatted,
      endDate: endDateFormatted,
    };
    setFilterObject(payload);
  };
  const resetSelection = () => {
    reset({ assign_user: null, companyid: null });
    setRowCheck(false);
    setRowId([]);
    setSelectedRows([]);
  };
  return (
    <>
      <div className={`${pageClass} own-leads-page`}>
        <div className="bg-[#FFFFFF] p-10 rounded-xl">
          <div className="flex items-center justify-between flex-col sm:flex-row sm:gap-4 sm:py-4">
            <h1 className={`${pageHeader} sm:mb-0 whitespace-nowrap`}>
              Own Leads
            </h1>
            {(userDetails?.role?.roleName === "SuperAdmin" ||
              userDetails?.role?.roleName === "Admin") && (
                <div className="flex flex-wrap justify-center gap-2 sm:flex-nowrap sm:justify-end sm:items-center sm:gap-0">
                  <div className="flex justify-center w-full sm:w-auto">
                    <button
                      className={ExcelBtn}
                      onClick={() => submitPdfExcel("Csv")}
                    >
                      Excel
                    </button>
                    <button
                      className={pdfBtn}
                      onClick={() => submitPdfExcel("Pdf")}
                    >
                      PDF
                    </button>
                  </div>
                  <div className="flex justify-center w-full sm:w-auto">
                    <AddLeadd
                      edit={false}
                      Company={Company}
                      iniAssignUsers={AssignUsers}
                      filterRecords={filterRecords}
                      filterSubmit={filterSubmit}
                    />
                    {userDetails?.role?.roleName === "SuperAdmin" && (
                      <AddLead2
                        edit={false}
                        Company={Company}
                        iniAssignUsers={AssignUsers}
                        filterRecords={filterRecords}
                      />
                    )}
                  </div>
                </div>
              )}
          </div>
          <div className="bg-white rounded-xl sm:py-2">
            <form
              onSubmit={handleSubmitForm1(filterSubmit)}
              className="flex flex-col lg:flex-row gap-3"
            >
              {/* FILTERS */}
              <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
                <div>
                  <select
                    name="Status"
                    className={`${inputClass} !bg-slate-100`}
                    {...registerForm1("leadStatus")}
                  >
                    <option value="">Leads Status</option>

                    {leadStatusOptions.map((status, index) => (
                      <option key={index} value={status}>
                        {status}
                      </option>
                    ))}

                  </select>
                </div>

                <div>
                  <input
                    type="text"
                    placeholder="Enter Leads Name / State"
                    className={inputClass}
                    {...registerForm1("search")}
                  />
                </div>

                <div>
                  <input
                    type="text"
                    placeholder="Mobile Number"
                    className={inputClass}
                    {...registerForm1("phoneNumber")}
                  />
                </div>

                <div>
                  <Controller
                    name="rangeDate"
                    control={controlForm1}
                    render={({ field }) => (
                      <RangePicker
                        {...field}
                        className="w-full h-[48px] rounded-lg border border-[#DFDFDF] bg-[#F9FAFB] px-3 shadow-none outline-none focus:outline-none focus:ring-0 hover:border-[#DFDFDF]"
                        placeholder={["Start date", "End date"]}
                      />
                    )}
                  />
                </div>
              </div>

              {/* BUTTONS */}
              <div className="flex gap-2 justify-end flex-shrink-0 items-center">
                <button
                  type="submit"
                  className={`${formBtn1} ${isApplyDisabled
                      ? "opacity-50 cursor-not-allowed"
                      : "bg-base-color"
                    }`}
                  disabled={isApplyDisabled}
                >
                  Apply
                </button>

                <button
                  type="button"
                  onClick={() => {
                    resetForm1();
                    setFilterObject(initialFilterState);
                    setIsApplyDisabled(true);
                  }}
                  className={`${formBtn2} ${isApplyDisabled
                      ? "opacity-50 border-base-color-1 cursor-not-allowed text-base-color"
                      : "border-base-color-1  text-base-color"
                    }`}
                  disabled={isApplyDisabled}
                >
                  Clear
                </button>
              </div>
            </form>
          </div>
          {RowCheck && (
            <div className="bg-white rounded-xl sm:py-2">
              <form
                onSubmit={handleSubmit(HandleAssignUsers)}
                className="flex flex-col lg:flex-row lg:items-center gap-2"
              >
                <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-y-3 gap-x-2">
                  {userDetails?.role?.roleName == "SuperAdmin" && (
                    <div>
                      <select
                        name="company_id"
                        placeholder="Company Name"
                        className={`${inputClass} !bg-slate-100 w-full`}
                        {...register("companyId")}
                        onChange={(e) => handleCompanySelect(e.target.value)}
                      >
                        <option value="">Select Company Name</option>
                        {Company?.map((data) => (
                          <option
                            className="text-black"
                            key={data?._id}
                            value={data?._id}
                          >
                            {data?.companyName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  <div>
                    <Controller
                      name="assign_user"
                      control={control}
                      rules={{ required: "User is required" }}
                      render={({ field }) => (
                        <>
                          <Select
                            value={field.value || null}
                            styles={customStyles}
                            options={assignToOptions}
                            placeholder="Select User"
                            maxMenuHeight={220}
                            menuPlacement="auto"
                            onChange={(selectedOption) => {
                              field.onChange(selectedOption); // Update form state
                              handleAssignChange(selectedOption); // Call custom function
                            }}
                            onInputChange={(inputValue, { action }) => {
                              if (action === "input-change") {
                                handleAssignChange(inputValue); // Call function on typing
                              }
                            }}
                            {...field}
                          />
                          {errors.assign_user && (
                            <Error title={errors.assign_user.message} />
                          )}
                        </>
                      )}
                    />
                  </div>
                  <div className="flex items-center gap-2">
                    <div>
                      <button
                        type="submit"
                        className={`${formBtn1} w-full text-center`}
                      >
                        Assign
                      </button>
                    </div>
                    <div>
                      <DeleteMultipleLeads RowId={RowId} count={RowId.length} filterRecords={filterRecords} resetSelection={resetSelection}/>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          )}
          <div className="mt-4">
            <Table
              key={selectedRows.length}
              columns={filteredColumns}
              data={LeadsData}
              paginatorCheck={true}
              prevIsValid={prevIsValid}
              nextIsValid={nextIsValid}
              pageNo={pageNo}
              pageChangeHandler={pageChangeHandler}
              recordChangeHandler={recordChangeHandler}
              register={register}
              records={records}
              loading={loader}
            />
          </div>
        </div>
      </div>
      <ModifyCallTimeModal
        edit={true}
        filterRecords={() => filterRecords(true)}
        hideTrigger={true}
      />
    </>
  );
}